import { RootState } from "../store/store";
import { FeatureFlagDetails } from "../models/feature-flag-details";

export const isRustled = (state: RootState) =>
  isFeatureEnabled(state.featureFlags.featureFlagDetails, "rustled");

export const isNavChangesEnabled = (state: RootState) =>
  isFeatureEnabled(state.featureFlags.featureFlagDetails, "addnavchanges");

export const useLiabilitiesRestApi = (state: RootState) =>
  isFeatureEnabled(
    state.featureFlags.featureFlagDetails,
    "useliabilitiesrestapi"
  );

export const isContributionPanelEnabled = (state: RootState) =>
  isFeatureEnabled(state.featureFlags.featureFlagDetails, "contributionpanel");

export const isDistributionHistoryEnabled = (state: RootState) =>
  isFeatureEnabled(
    state.featureFlags.featureFlagDetails,
    "distributionhistory"
  );

export const useNew457bLogic = (state: RootState) =>
  isFeatureEnabled(state.featureFlags.featureFlagDetails, "useNew457bLogic");

function isFeatureEnabled(
  featureFlags: FeatureFlagDetails,
  featureName: string
) {
  return (
    featureFlags &&
    featureFlags.enabledFeatures &&
    featureFlags.enabledFeatures.some(
      (enabledFeatureName) =>
        enabledFeatureName.toLowerCase() === featureName.toLowerCase()
    )
  );
}
